import generateInitialState from 'src/js/modules/element-settings/helpers/generate-initial-state';
import controlIds from '../constants/control-ids';
import { autoPaddingTargets } from '../constants/targets';

const generateColumnAppearanceInitialState = (controlSettings) => {
  const autoPaddingSetting = {
    elementIds: controlSettings[controlIds.VERTICAL_SPACING]?.elementIds || [],
    targets: autoPaddingTargets,
  };

  return generateInitialState([...Object.values(controlSettings), autoPaddingSetting]);
};

export default generateColumnAppearanceInitialState;
